export const useMaskPII = () => {
  return {
    mask: {
      'data-di-mask': true,
      'data-dd-privacy': 'mask',
      'data-cs-mask': true
    },
    unmask: {
      'data-di-unmask-field': true,
      'data-dd-privacy': 'allow'
    }
  };
};
